import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Plus, Minus, MessageCircleQuestion, MapPin, Stethoscope, ArrowRight } from 'lucide-react';
import { CLINIC, SEARCH_FAQS } from '../mock';
import { PageHero, SectionTitle, Reveal } from '../components/Shared';

export default function AskRheumatologist() {
  const [open, setOpen] = useState(0);

  return (
    <div>
      <PageHero eyebrow="Ask a Rheumatologist" title="Common questions patients ask" subtitle="Clear answers to the questions people search for most — and how our clinic can help across Ghaziabad, Noida and Delhi NCR." />

      <section className="py-16">
        <div className="container-x max-w-3xl">
          <SectionTitle eyebrow="Conditions & Care" title="Find the right specialist care" sub="If any of these sound like your situation, we can help. Tap a question to read more." />
          <div className="space-y-3">
            {SEARCH_FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={f.q} delay={(i % 4) * 50}>
                  <div className={`bg-white rounded-2xl border transition-colors ${isOpen ? 'border-teal-200' : 'border-teal-50'}`}>
                    <button onClick={() => setOpen(isOpen ? -1 : i)} className="flex items-start justify-between w-full text-left p-5 gap-4">
                      <span className="flex gap-3">
                        <MessageCircleQuestion size={20} className="text-teal-600 shrink-0 mt-0.5" />
                        <span className="font-semibold text-teal-900">{f.q}</span>
                      </span>
                      <span className={`grid place-items-center w-8 h-8 rounded-full shrink-0 transition-colors ${isOpen ? 'bg-teal-600 text-white' : 'bg-teal-50 text-teal-700'}`}>{isOpen ? <Minus size={16} /> : <Plus size={16} />}</span>
                    </button>
                    <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                      <div className="overflow-hidden">
                        <div className="px-5 pb-5 pl-14">
                          <p className="text-slate-600 leading-relaxed">{f.a}</p>
                          <a href={`tel:${CLINIC.phoneRaw}`} className="inline-flex items-center gap-2 text-teal-700 text-sm font-semibold mt-3"><Phone size={15} /> Call {CLINIC.phone}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <div className="mt-10 rounded-2xl border border-teal-100 bg-teal-50/60 p-6 flex gap-4">
            <span className="grid place-items-center w-11 h-11 rounded-xl bg-teal-600 text-white shrink-0"><MapPin size={22} /></span>
            <div>
              <h3 className="font-semibold text-teal-900 mb-1">Where we see patients</h3>
              <p className="text-slate-600 text-sm leading-relaxed">Srigyan Rheumatology Clinic, Crossings Republik, Ghaziabad · Consultations also in Noida &amp; Greater Noida. Serving patients across Delhi NCR.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="deep-section">
        <div className="container-x py-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <span className="grid place-items-center w-14 h-14 rounded-2xl bg-white/10 text-white"><Stethoscope size={26} /></span>
            <h2 className="text-white text-2xl md:text-3xl text-balance" style={{ fontWeight: 600 }}>Not sure where to start? We'll guide you.</h2>
          </div>
          <div className="flex gap-3 shrink-0">
            <a href={`tel:${CLINIC.phoneRaw}`} className="btn-coral inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold"><Phone size={18} /> Call Now</a>
            <Link to="/second-opinion" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold bg-white/10 text-white hover:bg-white/20 transition-colors">Second Opinion <ArrowRight size={18} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
